<template>
  <div class="row living-options">
    <card-tabs 
      class="col-12 w-100" 
      :tabs="[{
        active: projectConfig.nowSelling.livingOption.active,
        label: `${projectConfig.nowSelling.livingOption.label}s`,
        id: 'masterplan',
      }, {
        active: projectConfig.nowSelling.subsectionGroup.active,
        label: `${projectConfig.nowSelling.subsectionGroup.label}s`,
        id: 'subsectionGroups',
      },{ 
        active: projectConfig.nowSelling.subsectionGroup.active,
        label: `${projectConfig.nowSelling.subsection.label}s`,
        id: 'subsections',
      },{
        active: projectConfig.nowSelling.subsectionGroup.active,
        label: `${projectConfig.nowSelling.property.label}s`,
        id: 'properties',
      },{
        active: projectConfig.nowSelling.subsectionGroup.active,
        label: `${projectConfig.nowSelling.dwelling.label}s`,
        id: 'dwellings',
      },{
        active: projectConfig.nowSelling.package.active,
        label: `${projectConfig.nowSelling.package.label}s`,
        id: 'packages',
      }]"
      :active-tab="activeTab"
      @tabClick="navigateToTab"
    >
      <template v-slot:masterplan>
        <LivingOptionsMasterplan></LivingOptionsMasterplan>
      </template>
      <template v-slot:subsectionGroups>
        <LivingOptionsSubsectionGroups></LivingOptionsSubsectionGroups>
      </template>
      <template v-slot:subsections>
        <LivingOptionsSubsections></LivingOptionsSubsections>
      </template>
      <template v-slot:properties>
        <LivingOptionsProperties></LivingOptionsProperties>
      </template>
      <template v-slot:dwellings>
        <LivingOptionsDwellings></LivingOptionsDwellings>
      </template>
      <template v-slot:packages>
        <LivingOptionsPackages></LivingOptionsPackages>
      </template>
    </card-tabs>   
  </div>
</template>
<script>
import { camelCase } from 'lodash'
import CardTabs from '@/components/Cards/TabsCard'
import LivingOptionsMasterplan from './LivingOptionsMasterplan'
import LivingOptionsProperties from './LivingOptionsProperties'
import LivingOptionsDwellings from './LivingOptionsDwellings'
import LivingOptionsSubsectionGroups from './LivingOptionsSubsectionGroups'
import LivingOptionsSubsections from './LivingOptionsSubsections'
import LivingOptionsPackages from './LivingOptionsPackages'

export default {
  components: { CardTabs, LivingOptionsMasterplan, LivingOptionsProperties, LivingOptionsDwellings, LivingOptionsSubsectionGroups, LivingOptionsSubsections, LivingOptionsPackages },

  data () {
    return {
      projectConfig: this.$store.state.config.projectConfig
    }
  },

  computed: {
    activeTab () {
      return camelCase(this.$route.name)
    }
  },

  beforeRouteEnter(to, from, next) {
    if (to.path === '/live') {
      next('/live/masterplan')
    } else {
      next()
    }
  },

  beforeRouteUpdate (to, from, next) {
    if (to.path === '/live') {
      next('/live/masterplan')
    } else {
      next()
    }
  },

  methods: {
    navigateToTab (tab) {
      this.$router.push('/live/' + tab)
    }
  }
}
</script>
<style lang="scss">
@import "@/styles/_mixins.scss";

.card {
  z-index: unset !important;
}

.living-option, .subsection, .property, .dwelling {
  border-radius: 4px;
  padding: 7px;
  border: 1px solid #d4d4d4;
  margin: 1em 0;
}

.selection-list {
  border-radius: 4px;
  padding: 7px;
  border: 1px solid #d4d4d4;   
  max-height: 200px;
  overflow: scroll; 
}

.list-wrapper {
  max-height: 600px;
  overflow: scroll;
}

.modal-row-padding {
  display: flex;
  flex-wrap: wrap;
  margin: 0 auto;
  padding: 30px 15px;
}


.live-table {
  border-collapse: separate;
  border-spacing: 0;
  border: 1px solid #d4d4d4;
  border-radius: 6px;
  width: 100%;


  .table__button-cell {

    button {
      opacity: 0;
    }
  }

  tbody {
    display: block;
    max-height: none;
    overflow: auto;

    @include v-breakpoint(800px) {
      max-height: calc(100vh - 500px);
    }

    tr:hover {
      &:not(.active) {
        background-color: #e2e8f0;
      }

      .table__button-cell button {
        opacity: 1;
      }
    }
  }

  thead, tbody tr {
    display: table;
    width: 100%;
    table-layout: fixed;
  }

  thead {
    background-color: #e2e8f0;
    border-bottom: 1px solid #cbd5e0;
    font-size: 12px;
    position: sticky;
    text-transform: uppercase;
    top: 0;
    z-index: 10;
  }

  th {
    cursor: pointer;
  }

  th, td {
    font-weight: 400;
    padding: 10px 15px;
    user-select: none;
  }

  tr {
    &:nth-child(2n) {
      background-color: #edf2f7;
    }
  }
}


.tag-crm {
  background: #60f454;
  border: 1px solid darken(#60f454, 15%);
  border-radius: 3px;
  display: inline-block;
  font-size: 11px;
  margin: 0 8px 0 0;
  padding: 2px 8px;
}

.dot {
  background: #b8b8b8;
  border: 1px solid darken(#b8b8b8, 15%);
  border-radius: 50%;
  display: inline-block;
  height: 10px;
  margin-right: 6px;
  width: 10px;

  &--crm {
    background: #60f454;
    border: 1px solid darken(#60f454, 15%);
  }
}

.input-filter {
  border: 1px solid #eee;
  border-radius: 4px;
  padding: 0.25em .75em;
}
</style>